import React from 'react';
import { Trans } from 'react-i18next';
import { node, bool, func, number, string } from 'prop-types';
import classnames from 'classnames/bind';

import { getPriceUnitString } from '@dragonfruit/utils/priceUnit';
import styles from './TokenDropdownItem.scss';
const cx = classnames.bind(styles);

function TokenDropdownItem({
  price,
  children,
  selected,
  isContract,
  contractPeriod,
  billingCyclePerMonths,
  currency,
  displayCurrency,
  handleClick,
}) {
  const { displayPriceWithCurrency } = getPriceUnitString({
    billingCyclePerMonths,
    contractPeriod,
    isContract,
    price,
    currency,
    displayCurrency,
  });

  return (
    <li
      className={cx(styles.root, {
        selected,
      })}
      onClick={handleClick}
    >
      {children}
      <div className={styles.price}>
        <Trans i18nKey="premium.priceDisplayFormat">
          Price
          {displayPriceWithCurrency}
        </Trans>
      </div>
    </li>
  );
}

TokenDropdownItem.propTypes = {
  billingCyclePerMonths: number.isRequired,
  children: node.isRequired,
  contractPeriod: number.isRequired,
  currency: string.isRequired,
  displayCurrency: string.isRequired,
  handleClick: func.isRequired,
  isContract: bool.isRequired,
  price: number.isRequired,
  selected: bool,
};

TokenDropdownItem.defaultProps = {
  selected: false,
};

export default TokenDropdownItem;



// WEBPACK FOOTER //
// ./app/containers/Premium/components/TokenPack/components/TokenDropdownItem/TokenDropdownItem.jsx